module.exports = __webpack_public_path__ + "static/media/gala.b8f15246.jpg";